import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import cn from './../../lib/bem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import './header_component.scss';

const HeaderComponent = ({flagHeaderMobile, index, title}) => {
    
    const [ poliza, setPoliza ] = useState(null);

    useEffect(()=> {

        function sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }

        const cargarDatosPoliza = async () => {
            await sleep(index ? 500 : 0);
            setPoliza(JSON.parse(sessionStorage.getItem("infoPoliza")));
        }
        cargarDatosPoliza();
    },[])


    const history = useNavigate();
    const classes = cn("headerComponent");
    
    const heightDiv = flagHeaderMobile ? '160px' : '80px';
    const display = flagHeaderMobile ? 'block' : 'none';

    const regresarMep = () => {
        if(index){
            window.parent.postMessage('close-iframe', '*');
        } else {
            history('/');
        }
    }

    return (
        <div className={classes()} style={{height:heightDiv}}>
            <div className={classes('headerFVG')}>
                <div aria-label={'textHeader'} className={classes('headerArrow')} onClick={() => regresarMep()} >
                    <FontAwesomeIcon icon={faArrowLeft} />
                </div>
                <div className={classes('headerDisplay')} style={{display:display}}>
                    <p><b>{title}</b></p>
                    <p>Fondo Vida Garantizado</p>
                    <p>N° de P&oacute;liza: {poliza?.numpol}</p>
                </div>
            </div>
        </div>
    )

}

export default HeaderComponent